import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpeg";

export default function Logo({ className = "", height = 46 }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/")}
      className={`flex items-center select-none ${className}`}
      aria-label="The Career Counsellor home"
    >
      <img src={logo} alt="The Career Counsellor" style={{ height }} className="w-auto object-contain" />
    </button>
  );
}
